import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from '~/components/Button/Button.component';
import Card from '~/components/Card/Card.component';
import Col from '~/components/Col/Col.component';
import {
  calcularAlturaLargura,
  calcularAlturaLarguraIconeMedio,
} from '~/modules/Helper/calcularAlturaLargura';
import {
  tamanhoFonteDescricaoGrafico,
  tamanhoFonteDescricaoDestaqueMedio,
  tamanhoFonteIconeMedio,
  tamanhoFonteDestaqueMedio,
} from '~/modules/Helper/calcularTamanhoFonte';
import {
  AA_TEXT_ON_LIGHT,
  AA_TEXT_PRIMARY_ON_LIGHT,
  AA_SURFACE,
  AA_DISABLED_BG,
  AA_DISABLED_BORDER,
  resolveTextColor,
} from '~/modules/Helper/contrast.helper';
import media from '../../modules/Dashboard/components/mediaStyle';

export const FilterButton = styled(Button)`
  width: 35px !important;
  height: 30px !important;
  cursor: pointer;
  background-color: ${AA_DISABLED_BG} !important;
  color: ${AA_TEXT_ON_LIGHT} !important;
  display: block;
  float: right;
  opacity: 1;
  border: 1px solid ${AA_DISABLED_BORDER} !important;

  .anticon {
    color: ${AA_TEXT_ON_LIGHT} !important;
  }
`;

export const CardWrapper = styled(Card)`
  height: 100% !important;

  .ant-card-body {
    padding: 0 10px;
    height: calc(100% - 50px) !important;
    background-color: ${AA_SURFACE} !important;
    align-content: center;
  }

  .ant-card-body > div:nth-child(2),
  .ant-card-body > div:nth-child(2) > div,
  .ant-card-body > div:nth-child(2) > div > div,
  canvas {
    height: 100% !important;
    width: 100% !important;
  }

  .ant-card-extra {
    display: flex;
    align-items: flex-end;
  }

  .ant-select {
    margin-right: 15px;
  }

  &:hover ${FilterButton} {
    opacity: 1;
    transition: 300ms;
  }
`;

export const TituloSpan = styled.span`
  margin-bottom: 20px;
  font-size: 25px;
`;

/** Título do card de gráfico como h2 (AccessMonitor hx_01b). */
export const CardTitleHeading = styled.h2`
  margin: 0;
  padding: 0;
  font-size: ${({ theme }) => `${18 + 2 * (theme.zoomFonte || 0)}px`};
  font-weight: 500;
  line-height: 1.35;
  color: inherit;
`;

/** Botão quadrado 32px alinhado ao select de Exercício. */
export const VisualizarButton = styled(Link)`
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  min-width: 32px;
  margin-left: 8px;
  align-self: flex-end;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  border: 1px solid ${AA_DISABLED_BORDER};
  background-color: ${AA_DISABLED_BG};
  color: ${({ $color }) => $color || AA_TEXT_ON_LIGHT} !important;
  cursor: pointer;
  text-decoration: none;
  line-height: 1;

  .anticon {
    font-size: 16px;
    color: inherit !important;
  }

  &:hover,
  &:focus {
    opacity: 0.85;
    color: ${({ $color }) => $color || AA_TEXT_ON_LIGHT} !important;
  }
`;

export const DescricaoLinkExternoDiv = styled.div`
  margin: 15px;
  font-size: 1.8rem;
`;

export const DescricaoLinkExternoDivMedio = styled.div`
  font-size: 1.8rem;
  margin-top: 16%;
`;

export const IconeDiv = styled.div`
  text-align: center;
  font-size: 55px;
  margin-right: 20px;

  ${media.Mobile`
    float: 'left'
  `};
`;

export const StatisticSpan = styled.div`
  ${media.Desktop`
    position: relative;
    top: -5px;
  `}

  ${media.Mobile`
    position: relative;
    top: -5px;
  `}
`;

export const StyledCol = styled(Col)`
  background-color: transparent !important;
`;

export const StatisticSpanMedio = styled.div`
  background-color: transparent !important;

  ${media.Desktop`
    position: relative;
    top: 15px;
    padding-left: 15px;
  `} ${media.Mobile`
    position: relative;
    top: 0px;
  `};
`;

export const ValorDescricaoSpan = styled.span`
  font-size: 15px;
  font-weight: 500;
`;

export const ValorDestaqueDiv = styled.div`
  font-size: 25px;
`;

export const ValorSecundarioSpan = styled.span`
  font-size: 15px;

  span {
    font-weight: 700;
  }
`;

export const Grafico = styled.span`
  display: table;
  margin: auto;
`;

export const IconeMedioDiv = styled.div`
  ${media.Desktop`
    font-size: ${({ tamanho }) => tamanhoFonteIconeMedio(tamanho)};
    margin-top: 15px;
  `}

  ${media.Mobile`
    text-align: center;
    font-size: 65px;
  `}
`;

export const IconeMedioImg = styled.img`
  ${media.Desktop`
    height: ${({ tamanho }) => calcularAlturaLarguraIconeMedio(tamanho)};
    width: ${({ tamanho }) => calcularAlturaLarguraIconeMedio(tamanho)};
  `}

  ${media.Mobile`
    height: 60px;
    width: 60px;
  `}
`;

export const ValorDescricaoDestaqueMedioDiv = styled.div`
  ${media.Desktop`
    margin-top: 15px;
    font-size: ${({ tamanho }) => tamanhoFonteDescricaoDestaqueMedio(tamanho)};
    color: ${({ corFonte }) => resolveTextColor(corFonte)};
  `}

  ${media.Mobile`
    font-size: 15px;
    font-weight: 500;
  `}
`;

export const ValorDestaqueMedioDiv = styled.span`
  ${media.Desktop`
    font-size: ${({ tamanho }) => tamanhoFonteDestaqueMedio(tamanho)};
    color: ${({ corFonte }) => resolveTextColor(corFonte)};
    font-weight: 500;
  `}

  ${media.Mobile`
    div{
      font-size: 25px;
    }
  `}
`;

export const ValorSecundarioMedioSpan = styled.span`
  span {
    font-weight: 700;
  }

  ${media.Desktop`
    font-size: ${({ tamanho }) => tamanhoFonteDescricaoDestaqueMedio(tamanho)};
  `}

  ${media.Mobile`
    font-size: 15px;
  `}
`;

export const GraficoMedio = styled.div`
  div.g2plot-htmlStatistic,
  div.g2plot-htmlStatistic > div.ring-guide-html,
  div.g2-html-annotation {
    background-color: transparent !important;
  }

  font-size: 25px;
  height: ${({ tamanho }) => calcularAlturaLargura(tamanho)};
  width: ${({ tamanho }) => calcularAlturaLargura(tamanho)};

  div.g2plot-htmlStatistic > div.ring-guide-html > span.ring-guide-name {
    position: relative;
    top: 5px;
  }

  div.g2plot-htmlStatistic > div.ring-guide-html > span.ring-guide-value {
    font-size: 1.3rem !important;
  }

  ${media.Mobile`
      display: table;
      margin: auto;
      width: 125px;
      height: 125px;

      div.g2plot-htmlStatistic > div.ring-guide-html > span.ring-guide-name{
        position: relative;
        top: 5px
      }

      div.g2plot-htmlStatistic > div.ring-guide-html > span.ring-guide-value{
        font-size: 1.3rem !important;
      }
  `}
`;

export const DescricaoGrafico = styled.p`
  font-size: ${({ tamanho }) => tamanhoFonteDescricaoGrafico(tamanho)};
  font-weight: 700;
  margin: 0;
  padding: 0;
  color: ${AA_TEXT_PRIMARY_ON_LIGHT};
`;

export const GraficoDonut = styled.div`
  padding: 0.625em 0;
  ${media.Mobile``}
`;

export const GraficoPie = styled.div`
  padding: 0.625em 0;
  ${media.Mobile``}
`;

export const GraficoLine = styled.div`
  ${media.Mobile``}
`;

export const GraficoBar = styled.div`
  ${media.Mobile``}
`;

export const GraficoColumn = styled.div`
  ${media.Mobile``}
`;

export const NoDataContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: inherit;
`;
